import { Box } from '@mui/material';

import { ClientDataType, ClientType } from 'model/client.model';
import { Link } from 'react-router-dom';
import zeplinColor from 'theme/Color';
import CustomClientCard from './CustomClientCard';

const ClientColumnGrid = ({
  clients,
  loading,
  category,
}: {
  clients: ClientDataType;
  loading: boolean;
  category: string | null;
}) => {
  if (loading) return <>Loading...</>;

  return (
    <>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(auto-fill, minmax(250px, 1fr))',
            sm: 'repeat(auto-fill, minmax(270px, 1fr))',
            md: 'repeat(auto-fill, minmax(280px, 1fr))',
            lg: 'repeat(auto-fill, minmax(290px, 1fr))',
            xl: 'repeat(auto-fill, minmax(300px, 1fr))',
          },
          gap: '24px',
          overflowY: 'auto',
          gridAutoRows: 'min-content',
          gridAutoFlow: 'row',
          height: { xs: 'calc(100vh - 190px)', xl: 'calc(100vh - 250px)' },
          alignItems: 'start',
          '& > a': {
            height: 'auto',
            display: 'block',
          },
        }}
      >
        {category && category === 'all'
          ? clients?.clients?.map((val: ClientType) => (
              <Link
                to={`huddle/${val.AccountId}`}
                state={{ client: val }}
                style={{ textDecoration: 'none', color: zeplinColor.BasicBlack }}
                key={val?.AccountId}
              >
                <CustomClientCard key={val.AccountId} client={val} loading={loading} />
              </Link>
            ))
          : clients?.clients
              ?.filter((val) => val.category === category)
              .map((val: ClientType) => {
                return (
                  <Link
                    to={`huddle/${val.AccountId}`}
                    state={{ client: val }}
                    style={{ textDecoration: 'none', color: zeplinColor.BasicBlack }}
                    key={val?.AccountId}
                  >
                    <CustomClientCard key={val.AccountId} client={val} loading={loading} />
                  </Link>
                );
              })}
      </Box>
    </>
  );
};

export default ClientColumnGrid;
